import Vue from 'vue';
import App from './app.vue';
import router from '@router';
import store from '@state/store';
import '@components/_globals';
import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';
import 'material-icons/iconfont/material-icons.scss';
import Notifications from 'vue-notification';
import PortalVue from 'portal-vue';
import Confirm from '@utils/confirm';
import state from '@state/store.js';
import 'flatpickr/dist/flatpickr.css';
import VueFlatPickr from 'vue-flatpickr-component';
import VueGtag from 'vue-gtag';
import Urls from '@constants';
import VueHtmlToPaper from '@utils/vue-html-to-paper';

const options = {
	name: '_blank',
	specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
	styles: [
		'https://semantic-ui.com/dist/semantic.min.css',
		'http://localhost:8081/pdf.css',
		'http://localhost:8081/md-latex.css',
		'http://localhost:8081/md-katex.css',
		'http://localhost:8081/md-texmath.css'
	]
};

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
	// Ensure tests fail when Vue emits an error.
	Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
}

Vue.use(SuiVue);
Vue.use(Confirm);
Vue.use(Notifications);
Vue.use(PortalVue);
Vue.use(VueFlatPickr);
Vue.use(VueHtmlToPaper, options);

Vue.use(
	VueGtag,
	{
		config: { id: Urls.GOOGLE_ANALYTICS }
	},
	router
);

Vue.directive('puede', function(el, binding) {
	// console.log( state.state.oidc.user, state.state.oidc.user.rol, state.state.oidc.user.rol );
	if (
		state.state.oidc.user &&
		state.state.oidc.user.rol &&
		binding.value.filter(
			(x) =>
				x
					.toString()
					.trim()
					.toUpperCase() ===
				state.state.oidc.user.rol
					.toString()
					.trim()
					.toUpperCase()
		).length > 0
	) {
		el.style.display = 'inherit';
	} else {
		// console.log(binding.value.toUpperCase());
		el.setAttribute('style', 'display:none!important;');
	}
});

Vue.directive('puede-disabled', function(el, binding) {
	// console.log( state.state.oidc.user, state.state.oidc.user.permiso, state.state.oidc.user.permiso );
	if (
		state.state.oidc.user &&
		state.state.oidc.user.rol &&
		binding.value.filter(
			(x) =>
				x
					.toString()
					.trim()
					.toUpperCase() ===
				state.state.oidc.user.rol
					.toString()
					.trim()
					.toUpperCase()
		).length > 0
	) {
		el.disabled = false;
	} else {
		el.disabled = true;
	}
});

const app = new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
	// Attach the app to the window, which can be useful
	// for manually setting state in Cypress commands
	// such as `cy.logIn()`.
	window.__app__ = app;
}
